var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            width: "800px",
            title: "选择单品",
            "before-close": _vm.handleClose,
            visible: _vm.Open,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.Open = $event
            },
          },
        },
        [
          _c("BaseTable", {
            ref: "baseTable",
            attrs: { "fn-init": _vm.Fninit, table: _vm.table },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { loading: _vm.loadingButton, type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.dialogConfirm()
                    },
                  },
                },
                [_vm._v(" 确定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }